import { SpinNumberInput } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { ConfigValueInputProps } from "./";

interface DecimalConfigValueInputProps extends ConfigValueInputProps {}

export const DecimalConfigValueInput = ({
  value,
  onUpdate,
  isReadOnly
}: DecimalConfigValueInputProps) => {
  const validateValidNumber = (inputValue: string | undefined) => {
    if (!inputValue) return "0";

    try {
      parseFloat(inputValue);
    } catch {
      return "0";
    }

    return inputValue;
  };

  const handleUpdate = (value: string | undefined) => {
    const validated = validateValidNumber(value);
    onUpdate(validated);
  };

  const { data: hasWritePermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementWrite
  );

  return (
    <SpinNumberInput
      value={value}
      onChange={handleUpdate}
      precision={3}
      disabled={isReadOnly || !hasWritePermission}
      title={!hasWritePermission ? NO_ACTION_PERMISSION : undefined}
    />
  );
};
